import { Cart } from '@frontastic-engbers/types/cart/Cart';

export const cartHasFreeShippingItemsOnly = (cart: Cart): boolean => {
  const giftCardLineItems: number =
    cart?.lineItems?.filter((lineItem) => lineItem.variant?.attributes?.IsFreeShipping)?.length ?? 0;

  return !!cart?.lineItems?.length && giftCardLineItems === cart.lineItems.length;
};
